var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWashingMachineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,21.5a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,0-1h-2A.5.5,0,0,0,16,21.5ZM17.5,2A1.5,1.5,0,1,0,19,3.5,1.5,1.5,0,0,0,17.5,2Zm0,2a.5.5,0,1,1,.5-.5A.5.5,0,0,1,17.5,4ZM12,21a6,6,0,1,0-6-6A6,6,0,0,0,12,21Zm0-11a5,5,0,1,1-5,5A5,5,0,0,1,12,10ZM18.5,0H5.5A2.5,2.5,0,0,0,3,2.5v19A2.5,2.5,0,0,0,5.5,24h13A2.5,2.5,0,0,0,21,21.5V2.5A2.5,2.5,0,0,0,18.5,0ZM6,1h5V3.5a.5.5,0,0,1-.5.5h-4A.5.5,0,0,1,6,3.5ZM20,21.5A1.5,1.5,0,0,1,18.5,23H5.5A1.5,1.5,0,0,1,4,21.5V7H20ZM20,6H4V2.5A1.5,1.5,0,0,1,5,1.09V3.5A1.5,1.5,0,0,0,6.5,5h4A1.5,1.5,0,0,0,12,3.5V1h6.5A1.5,1.5,0,0,1,20,2.5ZM14.5,4a.5.5,0,1,0,.5.5A.5.5,0,0,0,14.5,4ZM12,19a4,4,0,1,0-4-4A4,4,0,0,0,12,19Zm0-7a3,3,0,0,1,2.95,2.5H14.5a.5.5,0,0,0,0,1h.45A3,3,0,1,1,12,12Z",
    fill: "current",
    className: "color000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashingMachineIcon);
export default __webpack_public_path__ + "static/media/washing-machine-icon.2e6c8a9d97bb5f4b8b637f21578fbe39.svg";
export { ForwardRef as ReactComponent };